import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";

import PropertyImageEditor from "../propertyImageEditor/PropertyImageEditor";

/**
 * Domain-neutral image-editor dialog. Presentation only: no auth, routing,
 * or ownership logic. Chat and Property adapters pass class names and ids.
 */
function SharedImageEditorModal({
  show = false,
  sourceFile = null,
  kind,
  title = "Редагувати зображення",
  onApply,
  onCancel,
  disabled = false,
  restoreFocusRef = null,
  loading = false,
  loadError = null,
  className = "project-modal image-editor-modal",
  dialogClassName = "image-editor-modal__dialog",
  contentClassName = "image-editor-modal__content",
  bodyClassName = "image-editor-modal__body",
  testId = "image-editor-modal",
  titleId = "image-editor-modal-title",
}) {
  const [editorBusy, setEditorBusy] = useState(false);
  const closeLocked = editorBusy || disabled;
  const open = Boolean(show);

  const handleProcessingChange = useCallback((busy) => {
    setEditorBusy(Boolean(busy));
  }, []);

  const handleHide = () => {
    if (closeLocked) return;
    onCancel?.();
  };

  const handleEntered = () => {
    const root = document.querySelector(`[data-testid="${testId}"]`);
    const viewport = root?.querySelector(
      '[data-property-image-editor="viewport"]',
    );
    if (viewport && typeof viewport.focus === "function") {
      viewport.focus();
    }
  };

  const handleExited = () => {
    setEditorBusy(false);
    const el = restoreFocusRef?.current;
    if (el && typeof el.focus === "function" && document.contains(el)) {
      el.focus();
    }
  };

  return (
    <Modal
      show={open}
      onHide={handleHide}
      onEntered={handleEntered}
      onExited={handleExited}
      centered
      size="lg"
      backdrop={closeLocked ? "static" : true}
      keyboard={!closeLocked}
      restoreFocus={false}
      enforceFocus
      animation={false}
      className={className}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
      data-testid={testId}
      aria-labelledby={titleId}
    >
      <Modal.Header>
        <Modal.Title id={titleId}>{title}</Modal.Title>
        <button
          type="button"
          className="modal-btn-close"
          aria-label="Закрити"
          title="Закрити"
          disabled={closeLocked}
          onClick={handleHide}
        >
          <i className="fa-solid fa-xmark fa-2x" aria-hidden="true" />
        </button>
      </Modal.Header>
      <Modal.Body className={bodyClassName}>
        {loadError ? (
          <p className="form-hint text-danger" role="alert">
            {loadError}
          </p>
        ) : null}
        {open && sourceFile ? (
          <PropertyImageEditor
            sourceFile={sourceFile}
            kind={kind}
            title={title}
            embedded
            disabled={disabled}
            onApply={onApply}
            onCancel={onCancel}
            onProcessingChange={handleProcessingChange}
          />
        ) : null}
        {open && !sourceFile && !loadError && loading ? (
          <p className="form-hint" role="status">
            Завантаження зображення для редагування…
          </p>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}

export default SharedImageEditorModal;
